import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, vModelText as _vModelText, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "form-field-floating reactive my-4" }
const _hoisted_2 = ["value"]
const _hoisted_3 = { class: "form-field-floating reactive my-4" }
const _hoisted_4 = ["value"]
const _hoisted_5 = { class: "form-field-floating full my-5" }
const _hoisted_6 = ["label"]
const _hoisted_7 = ["value"]
const _hoisted_8 = {
  key: 0,
  class: "text-red"
}
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { class: "form-field-floating reactive my-4" }
const _hoisted_11 = {
  key: 0,
  class: "text-red"
}

import { ref, reactive, onMounted } from 'vue';
    import axios from 'axios';
import { MARKET_COMMANDE_MOTIF_REJET, MARKET_COMMANDE_MOTIF_REJET_OPTIONS_GROUPED } from '@/utils';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'MarketCommandeRejectModal',
  props: {},
  setup(__props, { expose: __expose }) {

    // @ts-expect-error raison: lib externe mal typée
    const props = __props;
    const isModalOpen = ref(false);
    let promise: Promise<any>;
    let resolvePromise: any;
    let rejectPromise: any;
    const errorMessage = ref('');
    const loading = ref(false);
    const isFormValid = ref(false);
    const commande = reactive({
        id: null as number | null,
        num_commande: '',
        created_at: '',
        user: {
            nom: '',
            prenom: '',
        }
    });
    const formData = reactive({
        motif_rejet_commande: 'CLIENT_REQUEST',
        commentaire_rejet_commande: '',
    });
    const errors = reactive({
        motif_rejet_commande: '',
        commentaire_rejet_commande: '',
    });

    async function open(_commande: any) {
        Object.assign(commande, _commande);
        promise = new Promise((resolve, reject) => {
            resolvePromise = resolve;
            rejectPromise = reject;
        });
        isModalOpen.value = true;
        return await promise;
    }

    function onClose() {
        resolvePromise(null);
    }

    function onReject() {
        resolvePromise(null);
        isModalOpen.value = false;
    }

    function validate() {
        let isValid = true;

        errors.motif_rejet_commande = '';
        if (!formData.motif_rejet_commande) {
            errors.motif_rejet_commande = "Le motif de rejet est requis";
            isValid = false;
        }

        if (formData.motif_rejet_commande === MARKET_COMMANDE_MOTIF_REJET.OTHER && !formData.commentaire_rejet_commande) {
            errors.commentaire_rejet_commande = "Le commentaire est requis lorsque le motif de rejet est 'Autre'";
            isValid = false;
        } else {
            errors.commentaire_rejet_commande = '';
        }

        isFormValid.value = isValid;
        
        return isValid;
    }

    async function onSubmit() {
        if (!validate()) { return; }
        loading.value = true;
        errorMessage.value = '';
        try {
            const formToUpload = {
                commande_id: commande.id,
                motif_rejet_commande: formData.motif_rejet_commande,
                commentaire_rejet_commande: formData.commentaire_rejet_commande,
            };

            const httpResponse = await axios.post(`/backoffice/market-commandes/reject/${commande.id}`, formToUpload);
            resolvePromise(httpResponse.data);
            isModalOpen.value = false;
        } catch(error: any) {
            errorMessage.value = error.message;
            console.error(error);
        } finally {
            loading.value = false;
        }
    }

    __expose({ open });

return (_ctx: any,_cache: any) => {
  const _component_custom_modal = _resolveComponent("custom-modal")!

  return (_openBlock(), _createBlock(_component_custom_modal, {
    show: isModalOpen.value,
    "onUpdate:show": _cache[2] || (_cache[2] = ($event: any) => ((isModalOpen).value = $event)),
    onClosed: onClose
  }, {
    header: _withCtx(() => [...(_cache[3] || (_cache[3] = [
      _createElementVNode("div", { style: {"flex":"1","display":"flex","flex-direction":"row","justify-content":"space-between"} }, [
        _createElementVNode("h4", { class: "font-semibold" }, "Rejeter la commande")
      ], -1)
    ]))]),
    footer: _withCtx(() => [
      _createElementVNode("button", {
        id: "btn-confirmation-confirm",
        class: "btn-ultra white2",
        style: {"justify-content":"center"},
        onClick: onSubmit
      }, "Valider"),
      _createElementVNode("button", {
        id: "btn-confirmation-reject",
        class: "btn-ultra white2",
        style: {"justify-content":"center"},
        onClick: onReject
      }, "Annuler")
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", null, [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("input", {
            type: "text",
            class: "form-input",
            value: commande.num_commande,
            name: "num_commande",
            id: "num_commande",
            placeholder: "",
            autocomplete: "off",
            readonly: "true"
          }, null, 8, _hoisted_2),
          _cache[4] || (_cache[4] = _createElementVNode("label", { for: "num_commande" }, [
            _createTextVNode("Num Commande "),
            _createElementVNode("b", { class: "color-danger" }, "*")
          ], -1))
        ]),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("input", {
            type: "text",
            class: "form-input",
            value: commande.user.nom + ' ' + commande.user.prenom,
            name: "user_nom",
            id: "user_nom",
            placeholder: "",
            autocomplete: "off",
            readonly: "true"
          }, null, 8, _hoisted_4),
          _cache[5] || (_cache[5] = _createElementVNode("label", { for: "user_nom" }, [
            _createTextVNode("Membre "),
            _createElementVNode("b", { class: "color-danger" }, "*")
          ], -1))
        ]),
        _createElementVNode("div", _hoisted_5, [
          _withDirectives(_createElementVNode("select", {
            class: "form-input-select",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formData.motif_rejet_commande) = $event)),
            name: "motif_rejet_commande",
            id: "motif_rejet_commande"
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(MARKET_COMMANDE_MOTIF_REJET_OPTIONS_GROUPED), (reasonCategory, index) => {
              return (_openBlock(), _createElementBlock("optgroup", {
                key: 'reason_category_' + index,
                label: reasonCategory.category
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(reasonCategory.reasons, (reason, reasonIndex) => {
                  return (_openBlock(), _createElementBlock("option", {
                    value: reason.code,
                    key: 'reason_' + reasonIndex
                  }, _toDisplayString(reason.label), 9, _hoisted_7))
                }), 128))
              ], 8, _hoisted_6))
            }), 128))
          ], 512), [
            [_vModelSelect, formData.motif_rejet_commande]
          ]),
          _cache[6] || (_cache[6] = _createElementVNode("label", { for: "motif_rejet_commande" }, [
            _createTextVNode("Motif "),
            _createElementVNode("b", { class: "color-danger" }, "*")
          ], -1)),
          (!!errors['motif_rejet_commande'])
            ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(errors['motif_rejet_commande']), 1))
            : _createCommentVNode("", true)
        ]),
        (formData.motif_rejet_commande === 'OTHER')
          ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _withDirectives(_createElementVNode("textarea", {
                  class: "form-input lg",
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formData.commentaire_rejet_commande) = $event)),
                  name: "commentaire_rejet_commande",
                  id: "commentaire_rejet_commande",
                  rows: "3"
                }, null, 512), [
                  [_vModelText, formData.commentaire_rejet_commande]
                ]),
                _cache[7] || (_cache[7] = _createElementVNode("label", { for: "commentaire_rejet_commande" }, [
                  _createTextVNode("Commentaire "),
                  _createElementVNode("b", { class: "color-danger" }, "*")
                ], -1))
              ]),
              (!!errors['commentaire_rejet_commande'])
                ? (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(errors['commentaire_rejet_commande']), 1))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }, 8, ["show"]))
}
}

})